import {getRuntimeConfig} from '@/app/api/config/get-config';
import {getRequestContextHeaders} from '@/app/lib/core/get-request-context-headers';
import {createFetcher} from '@udemy-v2/graphql';

function isHeadersEmpty(options: RequestInit['headers']): boolean {
    if (!options) {
        return true;
    }

    if (options instanceof Headers) {
        // For Headers objects, check if any entries exist
        return !Array.from(options.entries()).length;
    }

    if (Array.isArray(options)) {
        // For string[][] format
        return options.length === 0;
    }

    if (typeof options === 'object') {
        // For Record<string, string> format
        return Object.keys(options).length === 0;
    }

    return true;
}

export async function getHeaders(options: RequestInit['headers'] = {}) {
    if (typeof window === 'undefined') {
        if (isHeadersEmpty(options)) {
            console.debug(
                'No headers provided when making GQL request from the server. This can potentially cause scope issues if you are requesting scoped resources. Make sure you include headers if you are using generated GQL API (IE: `useQuery.fetcher(variables, headers)`) in those cases.',
            );
        }
        return await getRequestContextHeaders(options as Readonly<Headers>);
    } else {
        return Promise.resolve(options);
    }
}

export const fetcher = createFetcher({
    getUrl: () => {
        const fullGraphQLUrl = new URL(getRuntimeConfig('GRAPHQL_URL'), 'https://www.udemy.com');
        const isServer = typeof window === 'undefined';
        return isServer
            ? fullGraphQLUrl.toString()
            : `${window.location.origin}${fullGraphQLUrl.pathname}`;
    },
    getHeaders,
    // Add custom options to the GraphQL fetcher (e.g., retry logic, custom headers) below
    // <<Stencil::Block(fetcherOptions)>>
    // <</Stencil::Block>>
});
